import {BaseResponse} from './internal/baseresponse';


export class UserValidateMobile {
  name: string;
  birthday: string;
  tel_com_cd: string;
  nation: string;
  sex: string;
  tel_no: string;
  auth_code: string;
}


export class UserVerifyMobile {
  cert_no: string;
}

export class UserVerifiyMobile {
  name: string;
  birthday: string;
  tel_com_cd: string;
  nation: string;
  sex: string;
  tel_no: string;
  auth_code: string;
}


export class UserValidateMobileResult extends BaseResponse {
  data: string;
}

export class UserVerifyMobileResult extends BaseResponse {
  data: string;
}


export class UserModifyResult extends BaseResponse {
  data: null;
}



// WEBPACK FOOTER //
// ./src/app/response/usermodifyresult.ts